import _ from "underscore";

export default {
  state: {
    isEnqueteOpen: false,
    enqueteMode: ""
  }
};
